export enum ShoppingCartItemPaymentType {
    Checkout = "checkout",
    Invoice = "invoice",
    InvoiceCheckout = "invoiceCheckout",
}